import type { ExplorerEvent, ExplorerState } from './explorer_state.js';

type Handler<K extends ExplorerEvent['t']> = (
  state: ExplorerState,
  ev: Extract<ExplorerEvent, { t: K }>,
) => ExplorerState;

/**
 * Os eventos da IDA do round trip, fora do `explorer_state.ts` pelo teto de
 * linhas dele. `outbound_chosen` fecha a fase 1 e abre a 2 (a volta em
 * `loading`, à espera da return-search). `outbound_gone` é o desfecho da busca
 * vencida refeita sem a ida escolhida (#5588, CT-6): a pessoa fica na fase 1,
 * com a lista nova e o aviso, que morre quando ela escolhe outra ida.
 */
export const OUTBOUND_HANDLERS: {
  outbound_chosen: Handler<'outbound_chosen'>;
  outbound_gone: Handler<'outbound_gone'>;
} = {
  outbound_chosen: (state, ev) => {
    const outbound = state.legs[0];
    if (state.request.mode !== 'round_trip' || outbound?.phase !== 'ready') return state;
    const seqs = [...state.seqs];
    seqs[1] = (seqs[1] ?? 0) + 1;
    return {
      ...state,
      chosen: { 0: { offerId: ev.offerId } },
      activeLeg: 1,
      seqs,
      legs: [outbound, { phase: 'loading' }],
      outboundGone: false,
    };
  },
  outbound_gone: (state) =>
    state.request.mode === 'round_trip' && state.activeLeg === 0
      ? { ...state, outboundGone: true }
      : state,
};
